import React, { useState } from "react";
import { NavLink } from "react-router-dom";

import { useAuth } from "../contexts/AuthContext";
import UserSettings from "./UserSettings";

export default function Header() {
	const { currentUser } = useAuth();

	const [showUser, setShowUser] = useState(false);

	return (
		<header className="header">
			<div className="links">
				<NavLink className="nav-link" activeclassname="active" to="/">
					<div className="icon">home</div>
					<div className="text">
						<p>Página principal</p>
					</div>
				</NavLink>
				<NavLink
					className="nav-link"
					activeclassname="active"
					to="/dashboard"
				>
					<div className="icon">token</div>
					<div className="text">
						<p>Mis autómatas</p>
					</div>
				</NavLink>
				{/* <NavLink
					className="nav-link"
					activeclassname="active"
					to="/acerca"
				>
					<div className="icon">info</div>
					<div className="text">
						<p>Acerca de</p>
					</div>
				</NavLink> */}
				<NavLink
					className="nav-link"
					activeclassname="active"
					to="/tutorial"
				>
					<div className="icon">help</div>
					<div className="text">
						<p>Tutorial</p>
					</div>
				</NavLink>
			</div>
			<button
				className="header-user"
				onClick={() => setShowUser(!showUser)}
			>
				{currentUser ? (
					<img
						src={currentUser.photoURL}
						alt={`Foto de perfil de ${currentUser.email}`}
					/>
				) : (
					<div className="user-icon">person</div>
				)}
			</button>

			<UserSettings open={showUser} />
			{showUser ? (
				<div
					className="click-outside"
					onClick={() => setShowUser(false)}
				></div>
			) : null}
		</header>
	);
}
